import { useMutation, useQueryClient } from '@tanstack/react-query';
import { saveWeeklyOffSetting } from '@api/nurses';
import { QUERY_BASE_KEY } from '@constants/query-key';
import type { WeeklyOffSettingConfig } from '@vTypes/weeklyOff';

interface SaveSettingsParams {
    payload: Partial<WeeklyOffSettingConfig>;
    groupId?: string;
}

/**
 * 주휴 설정 데이터를 저장하는 TanStack Query Mutation 훅
 * @param isAdmin - 관리자 여부. true이면 groupId를 사용하여 조회
 * @param groupId (관리자용) 저장 후 무효화할 쿼리 키에 사용될 그룹 ID
 * @returns TanStack Query의 `useMutation` 결과 객체 (mutate, isLoading 등)
 */
export const useSaveWeeklyOffSettingsMutation = ({ isAdmin, groupId }: { isAdmin: boolean; groupId?: string }) => {
    // 관리자인 경우에는 groupId가 필수
    const queryId = isAdmin ? groupId : undefined;

    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ payload, groupId }: SaveSettingsParams) => saveWeeklyOffSetting(payload, groupId),
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: [QUERY_BASE_KEY.WEEKLYOFF, 'settings', queryId] });
        },
        onError: (error) => {
            console.error("주휴 설정 저장 중 에러 발생:", error);
        },
    });
};
